import { render, staticRenderFns } from "./SignUpSecurityQuestions.vue?vue&type=template&id=5dcbc457&scoped=true&"
import script from "./SignUpSecurityQuestions.vue?vue&type=script&lang=js&"
export * from "./SignUpSecurityQuestions.vue?vue&type=script&lang=js&"
import style0 from "./SignUpSecurityQuestions.vue?vue&type=style&index=0&id=5dcbc457&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbc457",
  null
  
)

export default component.exports